 /* eslint-disable */
<template id="input-widget">
  <div v-if="node.input_type">
    <!-- 文本 -->
    <template v-if="node.input_type ==1">
      <input v-model="node.default"
             class="lp-question-input"
             :class="{'fc-primary': node.default}"
             type="text"
             :placeholder="node.input_title || node.action_tips"
             :name="node.id"
             @keyup="on_keyup(parentNode, node, $event)"
             @blur="input_complete(parentNode, node, $event)">
    </template>

    <!-- 日期 -->
    <template v-else-if="node.input_type == 2 ">
      <!-- <datepicker @picked="onInput_Date"></datepicker> -->
      <div class="lp-question-input"
           @click="onInput_Date">
        <span v-if="!node.default"
              class="d-placeholder">{{ node.input_title || node.action_tips || '请选择日期' }}</span>
        <span v-else>{{ node.default }}</span>
      </div>
    </template>

    <!-- N 日期+时间 -->
    <div v-else-if="node.input_type == 3 "
         style="position:relative;" />

    <!-- N 时间 -->
    <div v-else-if="node.input_type == 4 "
         style="position:relative;" />

    <!-- 正整数 -->
    <template v-else-if="node.input_type == 6">
      <input v-model="node.default"
             type="number"
             class="lp-question-input"
             required
             pattern="REG_POSITIVE_INTEGER"
             :placeholder="node.input_title || node.action_tips"
             :notMatchTips=" node.action_tips || '请输入正整数' || node.input_title "
             @keyup="on_keyup(parentNode, node, $event)">
    </template>

    <!-- 整数 -->
    <template v-else-if="node.input_type == 7">
      <input v-model="node.default "
             type="number"
             class="lp-question-input"
             required
             pattern="REG_INTEGER"
             :placeholder="node.input_title || node.action_tips"
             :notMatchTips="node.action_tips || '请输入整数' || node.input_title "
             @keyup="on_keyup(parentNode, node, $event)">
    </template>

    <!-- 小数 -->
    <!--     <div v-else-if="node.input_type == 8 " style="position:relative;">
      <float :input_placeholder="node.input_title || node.action_tips" :input_name="node.id" :value="node.default" @input="onInput_val" @keyup="on_keyup(parentNode, node, $event)" @blur_tell="input_complete(parentNode, node, $event)"></float>
    </div> -->

    <template v-else-if="node.input_type ==8">
      <input v-model="node.default"
             type="number"
             class="lp-question-input"
             required
             pattern="^[0-9]+(\.\d{1,2})?$"
             :placeholder="node.input_title || node.action_tips"
             :notMatchTips="node.action_tips || '请输入小数（最多两位小数）' || node.input_title "
             @keyup="on_keyup(parentNode, node, $event)">
    </template>

    <!-- 金额 -->
    <template v-else-if="node.input_type == 9">
      <input v-model="node.default"
             :class="{'fc-primary': node.default}"
             type="number"
             class="lp-question-input"
             required
             pattern="^([1-9](\d+)?(\.\d{1,2})?$)|(^(0){1}$)|(^\d\.\d{1,2}?$)"
             :placeholder="node.input_title || node.action_tips"
             :notMatchTips="node.action_tips || '请输入金额' || node.input_title "
             @keyup="on_keyup(parentNode, node, $event)">
    </template>

    <!-- 年龄-->
    <template v-else-if="node.input_type == 10">
      <input v-model="node.default"
             type="number"
             class="lp-question-input"
             required
             pattern="^[0-9][0-9]?$"
             :placeholder="node.input_title || node.action_tips"
             :notMatchTips="node.action_tips || '请输入年龄（0-99）' || node.input_title "
             @keyup="on_keyup(parentNode, node, $event)">
    </template>

    <!-- 身份证 -->
    <template v-else-if="node.input_type == 11">
      <input v-model="node.default"
             type="number"
             class="lp-question-input"
             required
             pattern="REG_IDNUM"
             :placeholder="node.input_title || node.action_tips"
             :notMatchTips="node.action_tips || '请输入正确的身份证号码' || node.input_title "
             @keyup="on_keyup(parentNode, node, $event)">
    </template>

    <!-- 手机号码 -->
    <template v-else-if="node.input_type == 12">
      <input v-model="node.default"
             type="tel"
             class="lp-question-input"
             required
             pattern="^[1][3,4,5,6,7,8,9][0-9]{9}"
             :placeholder="node.input_title || node.action_tips"
             :notMatchTips="node.action_tips || '请输入手机号码' || node.input_title "
             @keyup="on_keyup(parentNode, node, $event)"
             :class="{'fc-primary':node.default}">
    </template>

    <!-- 多行文本 -->
    <template v-else-if="node.input_type == 13">
      <textarea v-model="node.default"
                maxlength="200"
                class="lp-question-input"
                :class="{'fc-primary':node.default}"
                rows="5"
                :placeholder="node.input_title || node.action_tips || '请输入内容'"
                @keyup="on_keyup(parentNode, node, $event)" />
    </template>

    <!-- 民族 -->
    <template v-else-if="node.input_type == 14 ">
      <div class="lp-question-input"
           @click="onInputNation(node.default)">
        <span v-if="!node.default"
              class="d-placeholder">{{ node.input_title || node.action_tips || '请选择民族' }}</span>
        <span v-else>{{ node.default }}</span>
      </div>
    </template>

    <div v-else-if="node.input_type == 21 && node.input_widget">
      <!-- {#自定义输入组件#} -->
      <select v-if="(node.input_widget.widget_type == 2 || node.value=='select')&& (node.input_widget.action_type == 1 || node.input_widget.action_type == 4) && node.input_widget.items"
              v-model="node.default"
              class="form-control"
              :name="node.id"
              @change="input_complete(parentNode, node, $event)">
        <option value="">
          无
        </option>
        <option v-for="item in node.input_widget.items"
                :key="item.id"
                :value="item.id">
          {{ item.title }}
        </option>
      </select>

      <!-- <select
        v-else-if="node.input_widget.widget_type == 1 && (node.input_widget.action_type == 1 || node.input_widget.action_type == 4) && node.input_widget.items"
        v-model="node.default"
        class="lp-question-input"
        required
        @change="input_complete(parentNode, node, $event)"
      >
        <option
          value=""
          disabled
          selected
          hidden
        >
          请选择
        </option>
        <option
          v-for="(item,ii) in node.input_widget.items"
          :key="'key-'+ii"
          :value="item.id"
        >
          {{ item.title }}
        </option>
      </select> -->

      <div class="lp-question-widget-select"
           v-else-if="node.input_widget.widget_type == 1 && (node.input_widget.action_type == 1 || node.input_widget.action_type == 4) && node.input_widget.items">
        <div class="lp-question-widget-select_item"
             :class="{'checked': node.default == item.id}"
             v-for="(item,ii) in node.input_widget.items"
             :key="'key-'+ii"
             @click="setSelectcomplete(item, parentNode, node, $event)">
          <div class="cells-check__icon"></div>
          <div class="cells-check__title">{{ item.title }}</div>
        </div>
      </div>

      <label v-for="item in node.input_widget.items"
             v-else-if="node.input_widget.action_type == 2"
             :key="item.id"
             class="checkbox-inline">
        <input v-model="node.default"
               type="checkbox"
               :value="item.id"
               :name="node.id"> {{ item.title }}
      </label>
    </div>

    <!-- 地区 -->
    <template v-else-if="node.input_type == 22 ">
      <!-- <div
        @click="areaSelect(node.default)"
        class="lp-question-input"
      >  -->
      <div @click="areaselect.show=true;areaselect.showchild=true"
           class="lp-question-input">
        <span v-if="!node.default">{{ node.input_title || node.action_tips || '请选择地区' }}</span>
        <span v-else
              class="lp-question-input--primary">{{ node.default | filters_area_name }}</span>

      </div>
    </template>

    <div v-else-if="node.input_type == 23 && node.input_items">
      <!-- {#动态输入组件#} -->
      <template v-for="fields in node.items">
        <div v-for="item in fields"
             :key="item.id"
             class="form-group">
          <label v-if="node.is_required">{{ item.title }} </label>
          <input-widget v-if="node.is_required"
                        :node="item"
                        :parent-node="node"
                        @add_item="add_item" />
        </div>
      </template>
      <table v-if="!node.is_required"
             class="table table-hover"
             style="margin-bottom: 0px;">
        <tbody>
          <tr class="test_confirm_title_background">
            <th v-for="field in node.input_items"
                :key="field.id">
              {{ field.title }}
            </th>
            <th />
          </tr>
          <tr v-for="(fields,index) in node.items"
              :key="index">
            <td v-for="(item,indexs) in fields"
                :key="indexs">
              <input-widget :node="item"
                            :parent-node="node" />
            </td>
            <td>
              <a href="#"
                 @click.prevent="delete_item(index, node, $event)">x</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="form-group">
        <a href="#"
           class="add_line"
           @click.prevent="add_item(node, $event)">
          <span class="glyphicon glyphicon-plus"
                aria-hidden="true" /> 增加一行</a>
      </div>
    </div>

    <!-- 微信图片上传 -->
    <template v-else-if="node.input_type == 25 ">

      <Wechatuploadimg v-model="node"
                       @update="input_complete(parentNode, node, $event)" />
    </template>

    <!-- 五星评价 -->
    <template v-else-if="node.input_type == 26 ">
      <div class="lp-question-input lp-input-star fivestar">
        <template v-for="item in 5">
          <span :key="item"
                class="star"
                :class="starClasses(item)"
                @click="current_stars = item; node.default=item" />
        </template>
        <span class="tip">{{ current_tip[current_stars] }}</span>
        <!-- <span v-if="!node.default" class="d-placeholder">{{ node.input_title || node.action_tips || '请选择民族'}}</span>
          <span v-else>{{node.default}}</span> -->
      </div>
    </template>

    <!-- 在线签名 -->
    <template v-else-if="node.input_type == 28 ">
      <setsignature v-model="node.default" />
    </template>

    <!-- 在线签名 -->
    <template v-else-if="node.input_type == 27 ">
      <CountrySelector v-model="node.default" />
    </template>

    <div v-else-if="node.input_type == 29">
      <!-- 定制js选择 -->
      <working-todo-list v-if="node.input_args=='working_todo_list'"
                         :panel="1"
                         @update_value="update_value(parentNode, node, $event)" />
      <working-todo-list v-if="node.input_args=='working_todo_list2'"
                         :panel="2"
                         @update_value="update_value(parentNode, node, $event)" />
    </div>
    <div v-else>
      <input v-model="node.default"
             type="text"
             class="form-control"
             :placeholder="node.input_title || node.action_tips"
             :name="node.id"
             @keyup="on_keyup(parentNode, node, $event)"
             @blur="input_complete(parentNode, node, $event)">
    </div>
    <Areaselect :areaselect="areaselect"
                @getClose="areaselect.show=false"
                @update="chooseArea"
                v-if="areaselect.show"></Areaselect>
  </div>
</template>

<style lang="stylus">
.area-select
  position fixed
  left 0
  right 0
  top 0
  bottom 0
  width 100%
  height 100%
  z-index 1000
  color #333
  .content
    background #ffffff
    z-index 1010
    position absolute
    width 12.4rem
    position relative
    margin 10% auto 0
    border-radius 0.1rem
    padding 0.3rem
    box-shadow 0.1rem 0.1rem 0.3rem rgba(0, 0, 0, 0.1)
    .ht
      text-align center
      font-size 0.3rem
      color #333
      font-weight 600
      line-height 1
      padding 0.2rem 0 0.6rem 0
    .area-select_list
      display flex
      margin-bottom 0.2rem
      flex-wrap wrap
      a
        padding 0.05rem 0.24rem
        margin 0 0.1rem 0.2rem 0.1rem
        border-radius 0.06rem
        border solid 1px #ccc
        font-size 0.22rem
        color #333
        &.active
          background #3b6ae0
          color #fff
    .ft
      text-align center
      button
        width 2.03rem
        height 0.68rem
        background-color #3b6ae0
        border-radius 0.1rem
        font-size 0.28rem
        color #fff
  .mask
    background rgba(0, 0, 0, 0.5)
    position fixed
    left 0
    top 0
    right 0
    bottom 0
    z-index 1000
</style>

<script>
import Areaselect from '../Areaselect'
import { nations } from '../../datas/js/config.js'
import setsignature from './setsignature.vue'
import Wechatuploadimg from './com_wechat_uploadimg.vue'
import CountrySelector from './CountrySelector'
export default {
  name: 'InputWidget',
  components: {
    CountrySelector,
    Wechatuploadimg,
    setsignature,
    Areaselect
    // 'setsignature-input': require('./setsignature.vue')
  },
  filters: {
    filters_area_name: function (areadefault) {
      if (JSON.stringify(areadefault) === '{}') return ''
      if (typeof areadefault !== 'object' && areadefault !== '') {
        areadefault = JSON.parse(areadefault)
        return areadefault.name ? areadefault.name : ''
      } else if (typeof areadefault === 'object') {
        return areadefault.name ? areadefault.name : ''
      } else {
        return ''
      }
    }
  },
  props: ['parentNode', 'node'],
  data () {
    return {
      default_date: this.node.default ? this.node.default : '',
      current_tip: [
        '（未评价）',
        '（很差）',
        '（差）',
        '（一般）',
        '（好）',
        '（很好）'
      ],
      current_stars: 0,
      area_json: this.$store.state.device.areajson,
      areaSelects: { show: false, select: [] },
      areaselect: {
        show: false,
        showchild: false
      }
    }
  },
  methods: {
    onInput_val (val) {
      this.node.default = val
    },
    starClasses (index) {
      if (index <= this.current_stars) {
        return 'on'
      }
    },
    setSelectcomplete (item, node, childnode, event) {
      childnode.default = item.id
      this.$emit('update', event, node, childnode)
    },
    areaSelect (areadefault) {
      var that = this
      var city = ''
      console.log('123123', this)
      var deaultValue = []
      if (areadefault === '') {
        deaultValue = [
          '593f9c3bcf33985daebb17ba',
          '593f9c3ccf33985daebb180f',
          '593f9c3ccf33985daebb181a'
        ]
      }
      weui.picker(that.area_json, { //eslint-disable-line
        className: 'custom-classname',
        container: 'body',
        defaultValue: deaultValue,
        onChange: function (result) {
          city =
            result[1].label === '市辖区' ||
              result[1].label === '县' ||
              result[1].label === '直辖县市'
              ? ''
              : result[1].label
          that.node.default = {
            name: result[0].label + city + result[2].label,
            id: result[2].value,
            value: result[2].label
          }
          console.log(result)
          console.log(that.node.default)
        },
        onConfirm: function (result) {
          city =
            result[1].label === '市辖区' ||
              result[1].label === '县' ||
              result[1].label === '直辖县市'
              ? ''
              : result[1].label
          that.$emit('update', 'event', that.parentNode, that.node)
        },
        id: 'doubleLinePicker'
      })
    },
    onInputBlue (parentNode, node, event) {
      console.log(event.target.value)
      weui.form.checkIfBlur('#id_post_m_form', { //eslint-disable-line
        regexp: {
          IDNUM: /(?:^\d{15}$)|(?:^\d{18}$)|^\d{17}[\dXx]$/,
          VCODE: /^.{4}$/
        }
      })
    },
    onInputNation (val) {
      let _this = this
      val = val || '汉族'
      weui.picker(nations, { //eslint-disable-line
        defaultValue: [val],
        onChange: function (result) {
          console.log(result)
        },
        onConfirm: function (result) {
          _this.node.default = result[0].value
          _this.$emit('update', 'event', _this.parentNode, _this.node)
          console.log(result)
        }
      })
      console.log(this)
    },
    onInput_Date (year, month, date) {
      let _this = this
      weui.datePicker({ //eslint-disable-line
        start: 1990,
        end: new Date().getFullYear() + 50,
        defaultValue: [2018, 5, 19],
        onChange: function (result) {
          console.log(result)
        },
        onConfirm: function (result) {
          _this.node.default =
            result[0].value + '-' + result[1].value + '-' + result[2].value
          _this.$emit('update', 'event', _this.parentNode, _this.node)
          console.log(result)
        }
      })
      // this.node.default = year + '-' + month + '-' + date
      // console.log(year + '-' + month + '-' + date)
      // this.$emit('update', 'event', this.parentNode, this.node)
    },
    update_value (node, childnode, val) {
      childnode.default = val
      this.$emit('update', 'event', node, childnode)
    },
    input_complete (node, childnode, event) {
      this.$emit('update', event, node, childnode)
    },
    on_keyup (node, childnode, event) {
      console.log('keyup')
      this.$emit('on_keyup', event, node, childnode)
    },
    add_item (node, event) {
      var row = []
      var i = {}
      var l = node.items.length
      node.input_items.forEach(function (item) {
        i = {}
        $.extend(i, item) //eslint-disable-line
        i.id = i.id + '_' + l
        i.default = ''
        row.push(i)
      })

      node.items.push(row)
      return false

      // this.$emit('add_item', node, event);
      // return false;
    },
    delete_item: function (index, node, event) {
      node.items.splice(index, 1)
      return false
    },
    chooseArea (value) {
      console.log(value)
      this.node.default = {
        name: `云南省-${value[0].label}-${value[1].label}`,
        id: value[1].value,
        value: value[1].label
      }
      console.log(this.node, 'this.node')
      this.$emit('update', 'event', this.parentNode, this.node)
    }
  }
}
</script>
 /* eslint-disable */
